import { PricingPlan } from 'types/pricing_plan';

import { useCurrentPlan } from './useCurrentPlan';

type PlanCapability = {
  [K in keyof PricingPlan]: PricingPlan[K] extends boolean ? K : never;
}[keyof PricingPlan];

export function usePlanCapability(capability: PlanCapability) {
  const { data: currentPlan, isLoading, isSuccess } = useCurrentPlan();

  const isEnabled =
    (isSuccess && currentPlan === null) || Boolean(currentPlan?.[capability]);
  const isDisabled = !isLoading && !isEnabled;

  return { isEnabled, isDisabled, isLoading };
}
